import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import config from "./config";
import { PRODUCT_NAME } from "./config";
import {
  createBaseRoutes,
  createRouterGuard,
  createTitleGuard
} from "@shared/router/createBaseRoutes";

Vue.use(VueRouter);

import UpscaleView from "./views/UpscaleView.vue";
import ResultView from "./views/ResultView.vue";
import GalleryView from "./views/GalleryView.vue";

const routes = [
  {
    path: "/",
    name: "Upscale",
    component: UpscaleView,
    meta: { requiresAuth: true, allowAnonymous: true, title: `Enhance | ${PRODUCT_NAME}` }
  },
  {
    path: "/images/:id",
    name: "Result",
    component: ResultView,
    meta: { requiresAuth: true, allowAnonymous: true, title: `Result | ${PRODUCT_NAME}` }
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: GalleryView,
    meta: { requiresAuth: true, allowAnonymous: true, title: `Gallery | ${PRODUCT_NAME}` }
  },
  ...createBaseRoutes(config)
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If browser back/forward button was used and there's a saved position, use it
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise, always scroll to top when navigating to a new route
    return { x: 0, y: 0 };
  }
});

router.afterEach(createTitleGuard(config));

// Navigation guards
router.beforeEach(createRouterGuard(store, config));

export default router;
